/** DO NOT EXPORT ANY OTHER TYPES **/
import { LazyModule } from 'owa-bundling-light';
export * from './__generated__/schema.all.interface';
export * from './defaultConfigurationConstant';
export type { ResolverContext } from './types/resolverContext';
export type { GraphQLResolveInfo } from './types/graphQLResolveInfo';
export type { LocalStateResolverCallbacks } from './types/LocalStateResolverCallbacks';
export type { LocalStateMutationFn } from './types/LocalStateMutationFn';
export type { LocalStateEventContext } from './types/LocalStateEventContext';

const lazyTypeDefinitions = new LazyModule(() => import('./schema/schema'));

export async function loadTypes() {
    return (await lazyTypeDefinitions.import()).default;
}
